export default __webpack_public_path__ + "static/media/rest-api.b254d1e8.svg";